
// Packages
import axios from "axios";

const reserveDate = (date, startTime, endTime, maxParticipants, setSuccess=null, setDisplayDate=null, refreshHook=null) => {
    /* 
        params:
            date: string; a new Date() object as a string; new Date().toDateString()
            setSuccess: hook function to update success const passed down from CalendarTile component
            setDisplayDate: hook function tp update displayDate const passed down from CalendarTile component

    */

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .post(`${process.env.REACT_APP_API_BASE_URL}api/create-update-examdate/`, {
        date: date,
        start_time: startTime,
        end_time: endTime,
        max_participants: maxParticipants,
        examdate_active: true,
        timeslot_active: true,
    }, {
        headers : {
            Authorization: `Bearer ${token}`
        }
    })
    .then((response) => {
        if (response.status === 200) {
            if (setSuccess && setDisplayDate) {
                setSuccess(true);
                setDisplayDate(date.split('T')[0]);
                refreshHook();
            } else {
                refreshHook();
            }
        }
    })
    .catch((error) => {
        console.log(error)
    });

};

export default reserveDate;